import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=af3f32da&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3f32da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af3f32da')) {
      api.createRecord('af3f32da', component.options)
    } else {
      api.reload('af3f32da', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=af3f32da&scoped=true&", function () {
      api.rerender('af3f32da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pMciZiFBSF1W/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports